import { render } from "./aging-report.vue?vue&type=template&id=677815f5"
import script from "./aging-report.vue?vue&type=script&lang=js"
export * from "./aging-report.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__